module.exports = __webpack_public_path__ + "media/images/desktop/recording-645e88438fb2442e2c93ac87faf7945a.svg";